<template>
  <div class="add-box">
    <el-form
      label-width="120px"
      :inline="true"
      class="demo-form-inline"
      label-position="right"
    >
      <el-form-item label="受助人身份证号:">
        <el-input v-model="searchRecInfo.recIdno" class="user-input" />
      </el-form-item>
      <el-form-item>
        <el-cascader
          ref="plan"
          v-model="searchRecInfo.productId"
          :options="planOptions"
          :props="planProps"
          class="user-input"
          clearable
          placeholder="选择互助计划"
          @change="planChange"
        />
      </el-form-item>

      <el-form-item style="margin-left: 20px">
        <el-button type="primary" icon="el-icon-search" @click.stop="searchInfo">
          查询
        </el-button>
      </el-form-item>
      <br>
      <div v-if="searchRecInfo.recRealName" class="search-con">
        <div class="search-con-item">
          <label class="search-con-item__label">受助人姓名:</label>
          <span>{{ searchRecInfo.recRealName }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">受助人身份证号:</label>
          <span>{{ searchRecInfo.recIdno }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">受助人联系电话:</label>
          <span>{{ searchRecInfo.recPhoneNumber }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">加入时间:</label>
          <span>{{ searchRecInfo.joinTime }}</span>
        </div>
        <div class="search-con-item">
          <label class="search-con-item__label">生效时间:</label>
          <span>{{ searchRecInfo.effectiveTime }}</span>
        </div>
        <div class="search-con-item">
          <span style="font-weight: bold">[{{ searchRecInfo.waitingDateFlag }}]</span>
        </div>
      </div>
      <el-form-item label="受助人职业:">
        <el-input v-model="searchRecInfo.career" />
      </el-form-item>
      <br>
      <el-form-item label="申请人姓名:">
        <el-input v-model="searchRecInfo.applicantName" />
      </el-form-item>
      <el-form-item label="申请人身份证号:">
        <el-input v-model="searchRecInfo.applicantIdno" />
      </el-form-item>
      <el-form-item label="申请人联系电话:">
        <el-input v-model="searchRecInfo.applicantPhoneNumber" maxlength="11" />
      </el-form-item>
      <el-form-item label="申请人微信号:">
        <el-input v-model="searchRecInfo.applicantWxNumber" />
      </el-form-item>
      <el-form-item label="申请人联系邮箱:">
        <el-input v-model="searchRecInfo.applicantMailbox" />
      </el-form-item>
      <el-form-item label="申请人身份:">
        <el-cascader
          ref="title"
          v-model="searchRecInfo.titleTypeName"
          :options="titleOptions"
          :props="planProps"
          class="user-input"
          clearable
          placeholder="申请人身份"
          @change="titleChange"
        />
      </el-form-item>
      <el-form-item label="与受助人关系:">
        <el-cascader
          ref="relation"
          v-model="searchRecInfo.relationshipCode"
          :options="relationOptions"
          :props="planProps"
          class="user-input"
          clearable
          placeholder="与受助人关系"
          @change="relationChange"
        />
      </el-form-item>
      <br>
      <el-form-item label="收款人:">
        <el-input v-model="searchRecInfo.payee" />
      </el-form-item>
      <el-form-item label="开户银行:">
        <el-input v-model="searchRecInfo.bankName" />
      </el-form-item>
      <el-form-item label="银行卡号:">
        <el-input v-model="searchRecInfo.bankCard" />
      </el-form-item>
      <el-form-item label="支行信息:">
        <el-input v-model="searchRecInfo.branchInfo" />
      </el-form-item>
      <div class="title-line">
        <span class="divider-title">照片资料</span>
        <el-divider />
      </div>
      <div class="uploader_content">
        <ul id="picViewer" class="uploader_files">
          <li
            v-for="(item, index) in searchRecInfo.attachment"
            :key="index"
            class="uploader_file_block"
          >
            <div
              v-if="item.percentage < 100 && item.percentage > 0"
              class="uploader_file"
            >
              <el-progress type="circle" :percentage="item.percentage" />
            </div>
            <div v-else>
              <span
                class="uploader_file_del_icon"
                @click.stop="delLi(index)"
              ><i class="el-icon-close" style="color: white" /></span>
              <div v-if="item.url.substr(-3).includes('doc')">
                <a :href="item.url" class="doc-class" />
              </div>
              <div v-else-if="item.url.substr(-3).includes('pdf')">
                <a
                  :href="'/case/createPdfStream/?urlPath=' + item.url"
                  target="_blank"
                  class="pdf-class"
                />
              </div>
              <div v-else-if="item.url.substr(-3).includes('mp3')">
                <a :href="item.url" target="_blank" class="mp3-class" />
              </div>
              <div v-else class="uploader_file">
                <img
                  alt=""
                  :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
                  :data-original="item.url"
                >
              </div>
            </div>

            <span class="uploader_file_name">{{
              convertFilesName("attachment", item.url, item.name)
            }}</span>
          </li>
        </ul>
        <div class="uploader_file_uploader">
          <div class="uploader_input_wrp">
            <i class="el-icon-plus" style="font-size: 28px" />
            <input
              type="file"
              multiple="multiple"
              class="uploader_input"
              @change="chooseImage($event)"
            >
          </div>
        </div>
      </div>
      <el-form-item style="margin-top: 20px">
        <el-button type="primary" @click.prevent="save">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Checkout } from '@/utils/checkout' // 校验数据
const _checkout = new Checkout()

export default {
  data() {
    return {
      planOptions: [],
      planProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      },
      titleOptions: [],
      relationOptions: [],

      searchRecInfo: {
        applicantIdno: '',
        applicantMailbox: '',
        applicantName: '',
        applicantPhoneNumber: '',
        applicantWxNumber: '',
        attachment: [],
        bankCard: '',
        bankName: '',
        branchInfo: '',
        career: '',
        effectiveTime: '',
        joinTime: '',
        legalRelationship: '',
        payee: '',
        productId: '',
        productTypeName: '',
        recId: '',
        recIdno: '',
        recPhoneNumber: '',
        recRealName: '',
        relationshipCode: '',
        relationshipName: '',
        sex: 120200,
        titleTypeName: '',
        waitingDateFlag: ''
      },

      myViewer: null,

      bucketName: '',
      region: '',
      secretId: '',
      secretKey: ''
    }
  },

  watch: {},

  created() {
    this.$emit('setCurrentMenu', '添加案件')
    this.getplanList()
    this.getTitleEnumList()
    this.getRelationEnumList()
    this.getCosInfo()
  },

  mounted() {
    this.initPic()
  },

  methods: {
    getplanList() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/getPlanEnumList')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.enums
            vm.planOptions = data
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    getTitleEnumList() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/getTitleEnumList')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.enums
            vm.titleOptions = data
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    getRelationEnumList() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/getRelationEnumList')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.enums
            vm.relationOptions = data
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    getCosInfo() {
      this.axios
        .get(this.homePath() + '/case-info/getCosInfo')
        .then((res) => {
          const resData = res.data
          if (resData.status === '000000') {
            this.bucketName = resData.data.bucketName
            this.region = resData.data.region
            this.secretId = resData.data.secretId
            this.secretKey = resData.data.secretKey
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    initPic() {
      const pictures = document.getElementById('picViewer')
      // eslint-disable-next-line no-undef
      this.myViewer = new Viewer(pictures, {
        title: false,
        url: 'data-original'
      })
    },

    /**
     * 查询
     */
    searchInfo() {
      const vm = this
      const { searchRecInfo } = vm

      if (!searchRecInfo.recIdno) {
        vm.$message.error('请填写受助人身份证号')
      } else if (_checkout.checkCard(searchRecInfo.recIdno)) {
        vm.$message.error('请填写正确的受助人身份证号')
      } else if (!vm.searchRecInfo.productId) {
        vm.$message.error('请选择受助人的互助计划')
      } else {
        vm.axios
          .get(
            vm.homePath() +
              '/case/getRecInfoByIdNo/' +
              vm.searchRecInfo.productId +
              '/' +
              vm.searchRecInfo.recIdno
          )
          .then((res) => {
            if (res.data.status === '000000') {
              const data = res.data.recInfo
              if (data.applicantIdno != null) {
                vm.searchRecInfo.applicantIdno = data.applicantIdno
              }
              if (data.applicantMailbox != null) {
                vm.searchRecInfo.applicantMailbox = data.applicantMailbox
              }
              if (data.applicantName != null) {
                vm.searchRecInfo.applicantName = data.applicantName
              }
              if (data.applicantPhoneNumber != null) {
                vm.searchRecInfo.applicantPhoneNumber = data.applicantPhoneNumber
              }
              if (data.applicantWxNumber != null) {
                vm.searchRecInfo.applicantWxNumber = data.applicantWxNumber
              }
              if (data.attachment != null) {
                vm.searchRecInfo.attachment = data.attachment
              }
              if (data.bankCard != null) {
                vm.searchRecInfo.bankCard = data.bankCard
              }
              if (data.applicantIdno != null) {
                vm.searchRecInfo.applicantIdno = data.applicantIdno
              }
              if (data.applicantIdno != null) {
                vm.searchRecInfo.applicantIdno = data.applicantIdno
              }
              if (data.bankName != null) {
                vm.searchRecInfo.bankName = data.bankName
              }
              if (data.branchInfo != null) {
                vm.searchRecInfo.branchInfo = data.branchInfo
              }
              if (data.career != null) {
                vm.searchRecInfo.career = data.career
              }
              if (data.effectiveTime != null) {
                vm.searchRecInfo.effectiveTime = data.effectiveTime
              }
              if (data.joinTime != null) {
                vm.searchRecInfo.joinTime = data.joinTime
              }
              if (data.applicantIdno != null) {
                vm.searchRecInfo.applicantIdno = data.applicantIdno
              }
              if (data.payee != null) {
                vm.searchRecInfo.payee = data.payee
              }
              if (data.productId != null) {
                vm.searchRecInfo.productId = data.productId
              }
              if (data.productTypeName != null) {
                vm.searchRecInfo.productTypeName = data.productTypeName
              }
              if (data.recId != null) {
                vm.searchRecInfo.recId = data.recId
              }
              if (data.recIdno != null) {
                vm.searchRecInfo.recIdno = data.recIdno
              }
              if (data.recPhoneNumber != null) {
                vm.searchRecInfo.recPhoneNumber = data.recPhoneNumber
              }
              if (data.recRealName != null) {
                vm.searchRecInfo.recRealName = data.recRealName
              }
              if (data.relationshipCode != null) {
                vm.searchRecInfo.relationshipCode = data.relationshipCode
              }
              if (data.relationshipName != null) {
                vm.searchRecInfo.relationshipName = data.relationshipName
              }
              if (data.sex != null) {
                vm.searchRecInfo.sex = data.sex
              }
              if (data.titleTypeName != null) {
                vm.searchRecInfo.titleTypeName = data.titleTypeName
              }
              if (data.waitingDateFlag != null) {
                vm.searchRecInfo.waitingDateFlag = data.waitingDateFlag
              }
            } else {
              vm.$alert(res.data.message, '提示')
            }
          })
          .catch((error) => console.log(error))
      }
    },

    planChange(val) {
      this.searchRecInfo.productId = val
      this.searchRecInfo.productTypeName = this.$refs['plan'].getCheckedNodes()[0].label
    },

    titleChange(val) {
      this.searchRecInfo.legalRelationship = val
      this.searchRecInfo.productTypeName = this.$refs['title'].getCheckedNodes()[0].label
    },

    relationChange(val) {
      this.searchRecInfo.relationshipCode = val
      this.searchRecInfo.relationshipName = this.$refs[
        'relation'
      ].getCheckedNodes()[0].label
    },

    convertFilesName(type, url, obj) {
      if (type === 'valuationFilePicList') {
        var keyArray = url.split('.')
        var keySuffix = keyArray[keyArray.length - 1]
        if (keySuffix.toLowerCase() === 'doc') {
          return obj.replace(/-(.*?)_/i, '_')
        }
      }

      return obj.replace(/(.*?)_/i, '').replace(/(.*?)_/i, '')
    },

    chooseImage(event) {
      const that = this
      // let src
      // const url = window.URL || window.webkitURL || window.mozURL
      const files = event.target.files
      that.uploadImage(files)
      event.target.value = ''
    },

    uploadImage(files) {
      const vm = this
      for (let i = 0; i < files.length; i++) {
        const name = files[i].name.split('.')[0].trim() + '.' + files[i].name.split('.')[1]
        const key = new Date().getTime() + '_' + name
        const picObj = { url: '', name: key, percentage: 0 }
        vm.searchRecInfo['attachment'].push(picObj)
        const n = vm.searchRecInfo['attachment'].length - 1
        vm.upload_result(key, files[i], n)
      }
    },

    upload_result(key, fileObj, n) {
      const vm = this
      const COS = require('cos-js-sdk-v5')
      let cos = {}
      let Bucket = ''
      let Region = ''
      cos = new COS({
        SecretId: vm.secretId, // 密钥id
        SecretKey: vm.secretKey // 密钥的key
      })
      Bucket = vm.bucketName
      Region = vm.region

      cos.putObject(
        {
          Bucket: Bucket, // 桶名-APPID  必须
          Region: Region, // 区域 必须
          Key: key, // 文件名必须
          StorageClass: 'Standard_IA',
          Body: fileObj, // 上传文件对象
          onProgress: function(progressData) {
            vm.searchRecInfo['attachment'][n].percentage = progressData.percent * 100
          }
        },
        function(err, data) {
          if (err) {
            console.info(err)
            console.info({ success: false, msg: '文件上传失败!' })
            return
          }
          console.info({ success: true, msg: '上传成功!', data: data })
          const picUrl = 'http://' + Bucket + '.cos.ap-guangzhou.myqcloud.com/' + key
          const picObj = { url: picUrl, name: key }
          vm.searchRecInfo['attachment'][n] = picObj
          setTimeout(function() {
            vm.myViewer.update()
          }, 500)
        }
      )
    },

    delLi(index) {
      const vm = this
      vm.searchRecInfo.attachment.splice(index, 1)
      setTimeout(() => {
        vm.myViewer.update()
      }, 500)
    },

    /**
     * 创建案件信息
     */
    save() {
      const _this = this
      const { searchRecInfo } = _this

      if (!searchRecInfo.recIdno) {
        _this.$message.error('请填写受助人身份证号')
      } else if (_checkout.checkCard(searchRecInfo.recIdno)) {
        _this.$message.error('请填写正确的受助人身份证号')
      } else if (!searchRecInfo.applicantIdno) {
        _this.$message.error('请填写申请人身份证号')
      } else if (_checkout.checkCard(searchRecInfo.applicantIdno)) {
        _this.$message.error('请填写正确的申请人身份证号')
      } else if (!searchRecInfo.applicantPhoneNumber) {
        _this.$message.error('请填写申请人手机号码')
      } else if (_checkout.checkMobile(searchRecInfo.applicantPhoneNumber)) {
        _this.$message.error('请填写正确的申请人手机号码')
      } else if (!searchRecInfo.applicantMailbox) {
        _this.$message.error('请填写申请人电子邮箱地址')
      } else if (_checkout.checkEmail(searchRecInfo.applicantMailbox)) {
        _this.$message.error('请填写正确的申请人电子邮箱地址')
      } else {
        _this
          .axios({
            url: _this.homePath() + '/case/createCase',
            method: 'post',
            data: searchRecInfo,
            headers: {
              'Content-type': 'application/json'
            }
          })
          .then((res) => {
            const result = res.data
            if (result.status === '000000') {
              _this.$alert('保存成功', '提示', {
                callback: () => {
                  _this.$router.push('/index/allcase')
                }
              })
            } else {
              _this.$alert(result.message)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },

    back() {
      this.$router.push('/index/allcase')
    }
  }
}
</script>

<style></style>
